<template>
    <button
        :disabled="isLoading"
        :class="[
            'mt-4 inline-flex items-center justify-center gap-3 rounded-sm bg-primary px-4 py-2 text-2xl text-neutral-100 xl:mt-6 xl:px-6 xl:py-4',
            isLoading ? 'cursor-not-allowed opacity-60' : '',
        ]"
        :aria-busy="isLoading"
        @click="emit('click')"
    >
        <svg v-if="isLoading" class="size-6 animate-spin text-neutral-100" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
        </svg>

        <span>{{ isLoading ? loadingText : buttonText }}</span>
    </button>
</template>

<script setup lang="ts">
    defineProps<{
        isLoading: boolean;
        buttonText: string;
        loadingText: string;
    }>();

    // Emit event to parent component to trigger registration
    const emit = defineEmits<{
        (e: "click"): void;
    }>();
</script>
